'use strict';
const angular = require('angular');

export class newsFeedComponent {

  constructor(NewsService, Config, Auth) {
    'ngInject';

    this.NewsService = NewsService;
    this.Config = Config;
    this.currentPage = 1;
    this.isAdmin = Auth.isAdminSync();
  }

  $onInit() {

    let convertShortcode = (html) => {
      return html.replace(/\[/g,"<").replace(/\]/g,">");
    };

    this.itemsPerPage = this.itemsPerPage || 4;

    if (this.featured) {
      this.itemsPerPage = this.Config.getPaginationWithDefault("featuredNews", 3);

      let types = this.type;
      if (types) {
        types = types.replace(/ /g, '').split(",");
      }

      this.NewsService.getFeatured(data => {
        this.data = data.filter(news => !news.isDraft || (news.isDraft && this.isAdmin));

        if (types && types.length != 0) {
          this.data = this.data.filter(news => types.includes(news.type));
        }

        this.data.forEach(news => {
          news.body = convertShortcode(news.body);
        });
      }, err => {
        console.log('could not load featured news');
      });

    } else {
      this.NewsService.getByType({type: this.type}, data => {
        this.data = data;
        this.data.forEach(news => {
          news.body = convertShortcode(news.body);
        });
      }, err => {
        console.log('Could not retrieve news posts');
      });
    }
  }
}

export default angular.module('conduuApp.newsFeed', [])
  .component('newsFeed', {
    template: require('./news-feed.component.html'),
    bindings: {
      itemsPerPage: '@',
      type: '@',
      featured: '<'
    },
    controller: newsFeedComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/news-feed/news-feed.component.js